import FetchAiCostLimits from '@Application/AiCostLimits/Limits/Queries/FetchAiCostLimits';
import fetchAiCostLimits from '@Application/AiCostLimits/Limits/fetchAiCostLimits';
import { useDispatch, useStoreQuery } from '@verclam/synapse';

/** Reads the limits of the account, fetching them when the store holds none for it. */
const useAiCostLimits = (accountId: number | null, isEnabled = true) => {
	const dispatch = useDispatch();
	const enabled = isEnabled && accountId !== null;

	return useStoreQuery({
		selector: (state) => state.aiCostLimitsStore.limits,
		stopOn: (value) => !enabled || (value !== null && value.accountId === accountId),
		query: () => {
			if (!enabled) {
				return Promise.resolve();
			}

			return dispatch(fetchAiCostLimits(new FetchAiCostLimits(accountId)));
		},
		deps: [accountId, enabled],
	});
};

export default useAiCostLimits;
